<template>
  <div :class="`modal fixed z-50 w-screen h-screen top-0 left-0 flex items-center justify-center ${(show ? 'pointer-events-auto': 'opacity-0 pointer-events-none')}`">
    <div ref="wrap" class="modal-container text-center w-full z-50 pt-16 pb-12 max-h-screen overflow-y-scroll scrolling-touch">
      <button class="modal-overlay fixed top-0 left-0 w-full h-full bg-gray-900 opacity-75" @click="close" />
      <div class="modal-content inline-block relative text-center px-6 mx-auto">
        <button class="modal-close absolute top-0 right-0 -mt-10 mr-6 z-10" @click="close" >
          <img class="h-6 w-6 w-full h-full" src="~/assets/img/cross_white.svg" />
        </button>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name) {
      document.removeEventListener('keydown', this.onKeydown)
    }
    next()
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown)
  },
  watch: {
    show(val) {
      val && this.$refs.wrap.scrollTo(0, 0)
    }
  },
  methods: {
    onKeydown(e) {
      // 27 is the code for the escape key
      if (e.keyCode === 27) {
        this.close()
      }
    },
    close() {
      this.reset();
      this.$emit('close', true)
    },
    clearMessages() {
    },
    reset() {
      this.clearMessages();
    },
    goBack() {
      this.reset();
    },
    async register() {
      if (this.validate()) {
      }
    }
  }
}
</script>
